/**
 * Created by izagarelos on 24/4/2018.
 */
import { mapState, mapActions, mapMutations } from 'vuex';

const FacebookMixin = {
  data() {
    return {
      token: '',
      fb_params: {
        scope: '', // 'public_profile,email,user_posts',
        return_scopes: true,
        enable_profile_selector: true,
      },
    };
  },
  methods: {
    share(fbId, duelId, successCallback, failCallback) {
      this.checkLoginStatus(fbId, this.getFbUserInfo, (response) => {
        // eslint-disable-next-line
        console.log(response);
        this.userId = response.id;
        if (!fbId) {
          this.connectFbAccount().then(() => {
            if (this.userAuthorized) {
              this.getUserLoginDetails().then(() => {
                this.updateUserLanguage();
                localStorage.setItem('FacebookImage', response.picture.data.url);
                this.sendFacebookImage().then(() => {
                  this.updateDisplayAvatar();
                  this.storeUserAvatar(response.picture.data.url);
                  this.shareAction(duelId, successCallback);
                });
              });
            } else {
              // eslint-disable-next-line
              console.log('error on connect fb account');
              this.logout(failCallback);
            }
          });
        } else {
          this.shareAction(duelId, successCallback);
        }
      }, failCallback);
    },
    shareAction(duelId, successCallback) {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.shareModalRedirect(duelId);
      } else {
        this.shareModalPopup(duelId, successCallback);
      }
    },
    shareModalRedirect(id) {
      const postInfoObject = JSON.stringify({
        object: {
          'og:url': `${this.redirectUrl}?fb_ref=${id}`,
        },
      });
      const redirectionEndpoint = `${window.location.origin}/publicapi/fbShareRedirect?userId=${id}&action=${this.action}&callback=${window.location.href.includes('roundEnded') ? 'home' : ''}`;
      /* eslint-disable */
      window.location = 'https://m.facebook.com/v6.0/dialog/share?access_token=' + this.token +
        '&action_properties=' + encodeURIComponent(postInfoObject) +
        '&action_type=og.shares' +
        '&app_id=' + this.fbAppId +
        '&display=touch' +
        '&redirect_uri=' + encodeURIComponent(redirectionEndpoint) +
        '&sdk=joey' +
        '&version=v6.0';
      /* eslint-enable */
    },
    shareModalPopup(duelId, successCallback) {
      this.showShareModal(duelId, (resp) => {
        // eslint-disable-next-line
        console.log('resp:', resp);
        if (resp && !resp.error_code) {
          successCallback();
        }
      });
    },
    loginFbApi(fbId, callback, invalidFbError) {
      (async () => {
        window.FB.getLoginStatus(async (response) => {
          // eslint-disable-next-line
          console.log(response);
          if (response.authResponse && (response.status === 'connected' || response.status === 'not_authorized')) {
            this.token = response.authResponse.accessToken;
            localStorage.setItem('accessToken', response.authResponse.accessToken);
            this.authenticationValidation(response.authResponse.userID, fbId, this.getFbUserInfo, callback, invalidFbError);
          } else if (response.status === 'unknown') { // with the new fb version cookies are installed. Double check is needed to open pop up once
            await window.FB.login(async (res) => {
              // eslint-disable-next-line
              console.log(res);
              // eslint-disable-next-line
              console.log('Response from FB unknown');
              await window.FB.getLoginStatus((response1) => {
                // eslint-disable-next-line
                console.log(response1);
                if (response1.authResponse && (response1.status === 'connected' || response1.status === 'not_authorized')) {
                  this.token = response1.authResponse.accessToken;
                  localStorage.setItem('accessToken', response1.authResponse.accessToken);
                  this.authenticationValidation(response1.authResponse.userID, fbId, this.getFbUserInfo, callback, invalidFbError);
                }
              }, true);
            }, this.fb_params);
          } else {
            // eslint-disable-next-line
            console.log('Error in facebookIntegration during login...');
            invalidFbError();
          }
        }, this.fb_params);
      })();
    },
    checkLoginStatus(fbId, nextAction, callback, invalidFbError) {
      // https://gist.github.com/recca0120/c4fa99a358460e8189ab04907e8e96e4
      // https://stackoverflow.com/questions/16559115/fb-login-popup-block
      (async () => {
        window.FB.getLoginStatus(async (response) => {
          // eslint-disable-next-line
          console.log(response);
          if (response.authResponse && (response.status === 'connected' || response.status === 'not_authorized')) {
            this.token = response.authResponse.accessToken;
            this.authenticationValidation(response.authResponse.userID, fbId, nextAction, callback, invalidFbError);
          } else if (response.status === 'unknown') { // with the new fb version cookies are installed. Double check is needed to open pop up once
            await window.FB.login(async (res) => {
              // eslint-disable-next-line
              console.log(res);
              // eslint-disable-next-line
              console.log('Response from FB unknown');
              await window.FB.getLoginStatus((response1) => {
                // eslint-disable-next-line
                console.log(response1);
                if (response1.authResponse && (response1.status === 'connected' || response1.status === 'not_authorized')) {
                  this.token = response1.authResponse.accessToken;
                  this.authenticationValidation(response1.authResponse.userID, fbId, nextAction, callback, invalidFbError);
                }
              }, true);
            }, this.fb_params);
          }
        }, true);
      })();
      //   }
      // }, permissions);
    },
    authenticationValidation(userID, fbId, nextAction, callback, invalidFbError) {
      if (!fbId || userID === fbId) {
        nextAction(callback);
      } else {
        this.logout(invalidFbError);
      }
    },
    logout(callback) {
      window.FB.logout(() => {
        callback();
      });
    },
    connectFbAccount() {
      const userData = {
        accessToken: this.token,
        msisdn: this.userDetails.msisdn,
      };
      return this.callForAuthorizationFB(userData);
    },
    getFbUserInfo(callback) {
      window.FB.api('/me?fields=id,name,picture.width(300).height(300)', callback);
    },
    showShareModal(id, callback) {
      window.FB.ui({
        display: 'iframe',
        method: 'share',
        href: `${this.redirectUrl}?fb_ref=${id}`,
      }, callback);
    },
    forceFbToScrapNewMetadata(url, callback) {
      /* eslint-disable */
      window.FB.api(
        '/',
        'POST',
        { "scrape": "true", "id": url },
        callback);
      /* eslint-enable */
    },
    ...mapMutations('common', [
      'storeUserAvatar',
    ]),
    ...mapActions('common', [
      'sendFacebookImage',
      'updateDisplayAvatar',
    ]),
    ...mapActions('profile', [
      'callForAuthorizationFB',
      'getUserLoginDetails',
    ]),
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
  },
  computed: {
    ...mapState('profile', [
      'userAuthorized',
    ]),
    ...mapState('common', [
      'userDetails',
      'fbAppId',
    ]),
  },
};

export default FacebookMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/facebookIntegration.js